var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openJson(_vm.item)}}},[_vm._v("mdi-eye")])}
var staticRenderFns = []

export { render, staticRenderFns }